import "../css/home.css"
import show2 from "../images/small show2.jpg"

function Home() {
  return (
    <div className="home-container">
      <img className="home-img" src={show2} alt="show artwork"/>
    </div>
  )
}

export default Home;